import React from "react";
import { CounterpartyDirection } from "@common/helpers/counterparties";
import { CounterpartyEntityFilter } from "../CounterpartyEntityFilter/CounterpartyEntityFilter";
import { CounterpartiesFilters, getCounterpartyPresenceLabels } from "./lib";

interface Props {
    filters: CounterpartiesFilters;
    onChange: (value: CounterpartiesFilters) => void;
    hideNoVendor?: boolean;
    hidePresenceRows?: boolean;
    direction?: CounterpartyDirection;
    singleSelect?: boolean;
    entityLabel?: string;
    /**
     * Restricts the listed counterparties to those set as the customer on at
     * least one invoice. See CounterpartyEntityFilter.
     */
    invoiceCounterpartiesOnly?: boolean;
}

export const CounterpartyFilter: React.FC<Props> = ({
    filters,
    onChange,
    hideNoVendor,
    hidePresenceRows,
    direction,
    singleSelect,
    entityLabel,
    invoiceCounterpartiesOnly,
}) => {
    const { hasAssignedLabel, emptyLabel, noMatchLabel } =
        getCounterpartyPresenceLabels(entityLabel);

    return (
        <CounterpartyEntityFilter
            selectedIds={filters.counterpartiesIds}
            withEmpty={filters.withEmptyOrUnverifiedCounterparty}
            hasAssigned={filters.hasCounterparty}
            onChange={({ selectedIds, withEmpty, hasAssigned }) =>
                onChange({
                    counterpartiesIds: selectedIds,
                    withEmptyOrUnverifiedCounterparty: withEmpty,
                    hasCounterparty: hasAssigned,
                })
            }
            emptyLabel={emptyLabel}
            hasAssignedLabel={hidePresenceRows ? undefined : hasAssignedLabel}
            noMatchLabel={noMatchLabel}
            hideEmptyRow={hideNoVendor || hidePresenceRows}
            direction={direction}
            singleSelect={singleSelect}
            invoiceCounterpartiesOnly={invoiceCounterpartiesOnly}
        />
    );
};
